import { FC } from 'react';
import { useClarityRouteTracking } from '../../hooks/useClarityRouteTracking';

/**
 * Component to track route changes for Clarity
 * This must be placed inside Router context
 */
export const ClarityRouteTracker: FC = () => {
  useClarityRouteTracking();
  return null;
}; 